import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Segment,
  Container,
  Card,
  Button,
  Modal,
  Header
} from 'semantic-ui-react';

import {
  fetchTeam,
  clearTeam,
  fetchMembers,
  createMember,
  updateMember,
  deleteMember
} from '../actions/teams';

import TeamMember from '../components/TeamMember';
import TeamMemberForm from '../components/TeamMemberForm';

const CONFIRMED = 'Confirmed';
const PENDING = 'Pending confirmation';

class TeamMembers extends React.Component {
  constructor(props) {
    super(props);

    this.handleMemberInvite = this.handleMemberInvite.bind(this);
    this.handleMemberFormSubmit = this.handleMemberFormSubmit.bind(this);
    this.handleMemberDelete = this.handleMemberDelete.bind(this);

    this.state = {
      memberModalOpen: false,
      member: undefined
    };
  }

  componentWillMount() {
    this.props.fetchTeam(this.teamId);
    this.props.fetchMembers(this.teamId);
  }

  componentWillUnmount() {
    this.props.clearTeam();
  }

  get teamId() {
    return this.props.match.params.teamId;
  }

  get groupedMembers() {
    return (
      this.props.members &&
      this.props.members.reduce(
        (membersByStatus, member) => {
          if (member.confirmed) {
            membersByStatus[CONFIRMED].push(member);
          } else {
            membersByStatus[PENDING].push(member);
          }

          return membersByStatus;
        },
        {
          [CONFIRMED]: [],
          [PENDING]: []
        }
      )
    );
  }

  canEdit(team) {
    return team.policy.update;
  }

  openMemberModal() {
    this.setState({ memberModalOpen: true });
  }

  closeMemberModal() {
    this.setState({ memberModalOpen: false });
  }

  handleMemberFormSubmit(attributes) {
    if (this.state.member) {
      this.props.updateMember(this.teamId, this.state.member.id, attributes);
    } else {
      this.props.createMember(this.teamId, attributes);
    }
    this.closeMemberModal();
  }

  handleMemberInvite() {
    this.setState({ member: undefined });
    this.openMemberModal();
  }

  handleMemberDelete(memberId) {
    this.props.deleteMember(this.teamId, memberId);
  }

  render() {
    const { team } = this.props;

    // redirect if user does not have management permissions
    if (team && !this.canEdit(team)) {
      return (
        <Redirect
          to={{
            pathname: `/team/${team.slug}`
          }}
        />
      );
    }

    const { groupedMembers } = this;

    return (
      <Segment basic className="TeamMembers">
        <Modal
          size="small"
          open={this.state.memberModalOpen}
          onClose={() => this.setState({ memberModalOpen: false })}
        >
          <Modal.Header>Member details</Modal.Header>
          <Modal.Content>
            <TeamMemberForm
              member={{}}
              onSubmit={this.handleMemberFormSubmit}
            />
          </Modal.Content>
        </Modal>
        <Segment basic>
          <Container>
            <Button
              primary
              icon="add"
              content="Invite member"
              onClick={this.handleMemberInvite}
            />
          </Container>
        </Segment>
        <Container>
          {groupedMembers &&
            Object.keys(groupedMembers)
              .reverse()
              .map(
                groupId =>
                  groupedMembers[groupId].length > 0 && (
                    <Segment
                      key={`grouped-member-${groupId}`}
                      basic
                      clearing
                      vertical
                    >
                      <Header content={groupId} />
                      <Card.Group
                        key={`member-group-${groupId}`}
                        stackable
                        itemsPerRow={3}
                      >
                        {groupedMembers[groupId].map(member => (
                          <TeamMember
                            key={`member-${member.id}`}
                            member={member}
                            onDelete={this.handleMemberDelete}
                          />
                        ))}
                      </Card.Group>
                    </Segment>
                  )
              )}
        </Container>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  team: state.teams.team,
  members: state.teams.members
});

const mapDispatchToProps = dispatch => ({
  fetchTeam: teamId => {
    dispatch(fetchTeam(teamId));
  },
  clearTeam: () => {
    dispatch(clearTeam());
  },
  fetchMembers: teamId => {
    dispatch(fetchMembers(teamId));
  },
  createMember: (teamId, attributes) => {
    dispatch(createMember(teamId, attributes)).then(
      dispatch(fetchMembers(teamId))
    );
  },
  updateMember: (teamId, memberId, attributes) => {
    dispatch(updateMember(teamId, memberId, attributes)).then(
      dispatch(fetchMembers(teamId))
    );
  },
  deleteMember: (teamId, memberId) => {
    dispatch(deleteMember(teamId, memberId)).then(
      dispatch(fetchMembers(teamId))
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMembers);



// WEBPACK FOOTER //
// ./src/containers/TeamMembers.js